module.exports = __webpack_public_path__ + "2fe508f0fef99ae6f6aeacee93e88f27.jpg";